import { render, staticRenderFns } from "./VcCascader.vue?vue&type=template&id=29522a98&scoped=true"
import script from "./VcCascader.vue?vue&type=script&lang=js"
export * from "./VcCascader.vue?vue&type=script&lang=js"
import style0 from "./VcCascader.vue?vue&type=style&index=0&id=29522a98&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29522a98",
  null
  
)

export default component.exports